import { API_HOST, TOKEN_COOKIE_NAME } from './env';

const tokenKey = 'mozer-token';
const roleKey = 'litlsv-role';
const firstLoginKey = 'litlsv-first_login';
const nameKey = 'litlsv-name';

const getDomain = (location) => {
  const hostname = location ? location.hostname : 'localhost';
  const arr = hostname.split();
  if (arr.length > 1) {
    arr[0] = '';
    return arr.join('.');
  } else {
    return arr[0];
  }
}

const storeToken = (token) => {
  const domain = getDomain(window.location);
  localStorage.setItem(tokenKey, token);
  document.cookie = `${TOKEN_COOKIE_NAME}=${token}; domain=${domain}; path=/`;
}

export const storeRole = (role) => {
  localStorage.setItem(roleKey, role);
}

const storeAuth = (auth) => {
  storeToken(auth['token']);
  storeRole(auth['role']);
  localStorage.setItem(firstLoginKey, auth['first_login']);
  localStorage.setItem(nameKey, auth['name']);
}

const deleteToken = () => {
  const domain = getDomain(window.location);
  localStorage.removeItem(tokenKey);
  document.cookie = `${TOKEN_COOKIE_NAME}=''; domain=${domain}; path=/; max-age=0`;
};

const deleteAuth = () => {
  deleteToken();
  localStorage.clear();
};

export const localToken = () => {
  const token = localStorage.getItem(tokenKey);
  return token;
};

const isFirstLogin = () => {
  return localStorage.getItem(firstLoginKey) === 'true';
};

export const setFirstLogin = (b) => {
  return localStorage.setItem(firstLoginKey, b);
};

export const getName = () => {
  return localStorage.getItem(nameKey);
};

export default {
  // called when the user attempts to log in
  login: ({ username, password }) => {
    const request = new Request(API_HOST + '/api/auth/supervisor_login', {
      method: 'POST',
      body: JSON.stringify({ "email": username, "password": password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
      credentials: 'omit',
    });
    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          console.log("login error:" + response.statusText);
          console.log(response);
          throw new Error('ra.auth.sign_in_error');
        }
        return response.json();
      }).then(data => {
        storeAuth(data);
        if (data['first_login'] === true) {
          return Promise.resolve({ redirectTo: '/profiles/create' });
        }
      });
  },
  // called when the user clicks on the logout button
  logout: () => {
    deleteAuth();
    return Promise.resolve();
  },
  // called when the API returns an error
  checkError: (args) => {
    console.log(`checkError:${args}`);
    const { status } = args;
    if (status === 401 || status === 403) {
      deleteAuth();
      return Promise.reject();
    }
    return Promise.resolve();
  },
  // called when the user navigates to a new location, to check for authentication
  checkAuth: () => {
    const token = localToken();
    const request = new Request(API_HOST + '/api/supervisors/token', {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }),
      credentials: 'omit',
    });
    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          console.log("checkAuth error:" + response.statusText);
          console.log(response);
          deleteAuth();
          throw new Error('ra.auth.auth_check_error');
        }
        return response.json();
      }).then(data => {
        if (!data['token']) {
          console.log("checkAuth: contains no token");
          console.log(data);
          deleteAuth();
          throw new Error('ra.auth.auth_check_error');
        }
        storeAuth(data);
        return data;
      });
  },
  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: () => {
    const role = localStorage.getItem(roleKey);
    if (!role) {
      return Promise.reject();
    }
    const first = isFirstLogin();
    return Promise.resolve({
      isOwner: !first && (role === 'owner'),
      isFirstLogin: first,
    });
  },
  isFirstLogin: isFirstLogin,
};
